import script from "./AtlasGridView.vue?vue&type=script&setup=true&lang=js"
export * from "./AtlasGridView.vue?vue&type=script&setup=true&lang=js"

import "./AtlasGridView.vue?vue&type=style&index=0&id=3dbd8662&scoped=true&lang=css"

import exportComponent from "../../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbd8662"]])

export default __exports__